/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEquipmentMatch.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/equipment-match";

export class AutogenModelEquipmentMatch<RowType extends ModelRow> extends Endpoint<RowType, RowEquipmentMatchFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEquipmentMatch extends ModelRow<RowEquipmentMatchFields> {
	constructor(values?: Partial<RowEquipmentMatchFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEquipmentMatchFields {
	brk_qual_profile: string;
	brokerage_workflow_id: string;
	commodity_id: string;
	company_id: string;
	consignee_location_id: string;
	ctrl_party_id: string;
	customer_id: string;
	equipment_type_id: string;
	id: number;
	is_active: string;
	location_id: string;
	order_mode: string;
	order_type_id: string;
	priority: number;
	revenue_code_id: string;
	shipper_location_id: string;
	temperature_max: number;
	temperature_min: number;
	trailer_match: string;
}

